const BASE_URL = 'http://43.205.42.216:8000'

//Common
export const UPLOAD_IMAGE = `${BASE_URL}/common/upload-file/`

//Admin :: Settings
export const VISIT_TYPE = `${BASE_URL}/admin/visit-type/`
export const BANNER = `${BASE_URL}/admin/banner/`
export const SPECIALITY = `${BASE_URL}/admin/speciality/`
export const EDUCATION = `${BASE_URL}/admin/education/`
export const SPECIAL_INTEREST = `${BASE_URL}/admin/special_interest/`
export const STATE = `${BASE_URL}/admin/state/`
export const CITY_LIST = `${BASE_URL}/admin/city/`
export const TALUK = `${BASE_URL}/admin/taluk/`

//Admin :: Provider Management
export const USER_LIST = `${BASE_URL}/users/`
export const ADD_USER = `${BASE_URL}/users/sign-up/`
export const DOCTOR_LIST = `${BASE_URL}/doctors/`
export const SLOT_TYPE_LIST = `${BASE_URL}/admin/slot_type/`
export const DOCTORS_SLOT = `${BASE_URL}/doctors/doctor_slots/`
export const HOSPITAL_LIST = `${BASE_URL}/hospital/`

export const GET_IMA_BRANCH = `${BASE_URL}/admin/ima-branch/`
export const PHARMACY_LIST = `${BASE_URL}/pharmacy/`
export const SCAN_CENTER_LIST = `${BASE_URL}/scan-center/`
export const LABORATORY_LIST = `${BASE_URL}/laboratory/`
export const SCAN_CATEGORY_LIST = `${BASE_URL}/admin/scan_category/`
export const AMBULANCE_LIST = `${BASE_URL}/ambulance/`
export const BOOKING_LIST = `${BASE_URL}/booking/`
export const AMBULANCE_TYPE_LIST = `${BASE_URL}/ambulance/types/`
export const AMBULANCE_FACILITIES_LIST = `${BASE_URL}/ambulance/facilities/`
export const APPOINTMENT_DURATION_LIST = `${BASE_URL}/booking/list-appointment-duration/`
export const APPOINTMENT_STATUS_LIST = `${BASE_URL}/doctors/list-appointment-status/`

// Manage Pharmacy
export const List_Product_Type = `${BASE_URL}/pharmacy/list-product-type/`
export const List_SUB_PRODUCT_Type = `${BASE_URL}/pharmacy/list-pharmacy-product-subtypes/`
export const ADD_PRODUCT_SUB_CATEGORY = `${BASE_URL}/pharmacy/add-product-sub-category/`
export const DELETE_PRODUCT_SUB_TYPE = `${BASE_URL}/pharmacy/delete-product-sub-types/`
export const WEARABLE_SIZE_LIST = `${BASE_URL}/pharmacy/list-wearable-sizes/`
export const PRODUCT_TYPE_LIST = `${BASE_URL}/pharmacy/list-product-types/`
export const ADD_PRODUCT_TYPE = `${BASE_URL}/pharmacy/add-product-type/`
export const UPDATE_PRODUCT_TYPE = `${BASE_URL}/pharmacy/update-product-type/`
export const DELETE_PRODUCT_TYPE = `${BASE_URL}/pharmacy/delete-product-type/`
export const LIST_DRUG_COMPOSITION = `${BASE_URL}/pharmacy/list-drug-composition/`
export const ADD_DRUG_COMPOSITION = `${BASE_URL}/pharmacy/add-drug-composition/`
export const UPDATE_DRUG_COMPOSITION = `${BASE_URL}/pharmacy/update-drug-composition/`
export const DELETE_DRUG_COMPOSITION = `${BASE_URL}/pharmacydelete-drug-composition/`
export const UPDATE_SUB_CATEGORY_DATA = `${BASE_URL}/pharmacy/update-product-sub-type/`
export const LIST_COMPLAINT_CATEGORY = `${BASE_URL}/pharmacy/list-complaint-category/`
export const LIST_SUGGESTIONS_CATEGORY = `${BASE_URL}/pharmacy/list-suggestions-category/`
export const DELETE_PRODUCT_CATEGORY = `${BASE_URL}/pharmacy/delete-product-category/`
export const UPDATE_PRODUCT_CATEGORY = `${BASE_URL}/pharmacy/update-product-category/`
export const LIST_PRODUCT_CATEGORY = `${BASE_URL}/pharmacy/list-product-category/`
export const ADD_PRODUCT_CATEGORY = `${BASE_URL}/pharmacy/add-product-category/`
export const ADD_PRODUCT = `${BASE_URL}/pharmacy/add-product/`
export const LIST_PRODUCT = `${BASE_URL}/pharmacy/list-products/`
export const LIST_PRODUCT_DETAILS = `${BASE_URL}/pharmacy/list-product/products_id`
export const LIST_ORDER_MEDICINE = `${BASE_URL}/medicine-order/`
export const ADMIN_PRODUCT_DEATILS = `${BASE_URL}/pharmacy/list-product/products_id/`
export const PHARMACY_DETAILS = `${BASE_URL}/pharmacy/`
export const UPDATE_PRODUCT = `${BASE_URL}/pharmacy/update-product/`
export const PRODUCT_STATUS_CHANGE = `${BASE_URL}/pharmacy/activate-deactivate-product/`

// pharmacy Medicine
export const ADD_MEDICINE_PRODUCT = `${BASE_URL}/medicines/add-product/`
export const LIST_MEDICINE = `${BASE_URL}/medicines/list-medicines/`
export const DISPLAY_MEDICINE_DETAILS = `${BASE_URL}/medicines/display-medicine-details/`

// Active Pharmacy
export const APPROVED_PHARMACY_BY_ADMIN = `${BASE_URL}/pharmacy/activate/`

// Add Product Bulk Super Admin
export const ADD_PRODUCT_BY_EXCEL = `${BASE_URL}/pharmacy/add-product-excel-upload/`

// add Bulk Pharmacy By Admin
export const ADD_PHARMACY_BY_EXCEL = `${BASE_URL}/pharmacy/add-bulk-pharmacy-excel-upload/`

//Admin :: CMS
export const CMS_VIEW = `${BASE_URL}/cms-view/`

//Auth
export const LOGIN = `${BASE_URL}/admin/login/`
